import React from "react";
import Connection from "./Connection";
import Teleoperation from "./Teleoperation";
import { Row, Col, Container } from "react-bootstrap";

const Home = () => {
  return (
    <div>
      <Container>
        <h1 className="text-center mt-3">Robot Control Page</h1>
        <Row>
          <Col>
            <Connection />
          </Col>
        </Row>
        <Row>
          <Col>
            <Teleoperation />
          </Col>
          <Col>
            <h1>Map</h1>
            {/* <Map /> */}
          </Col>
        </Row>
        {/* <Row>
          <Col>
            <RobotState />
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default Home;
